document.querySelectorAll('[data-mt-compare]').forEach(function (root) {
  var range = root.querySelector('[data-mt-compare-range]');
  var after = root.querySelector('[data-mt-compare-clip]');
  var handle = root.querySelector('[data-mt-compare-handle]');

  function update(value) {
    after.style.clipPath = 'inset(0 ' + (100 - value) + '% 0 0)';
    handle.style.left = value + '%';
  }

  if (range && after && handle) {
    range.addEventListener('input', function (event) {
      update(event.target.value);
    });
  }
});
